$('.accordion--title-link').on('click',function(e){
	e.preventDefault();

	$('.accordion-block').not( $(this).attr('href') ).addClass('is-collapsed');
	$( $(this).attr('href') ).removeClass('is-collapsed');
	
});
